import { Grid } from '@material-ui/core';
import ProgressBar from '../../../../component/progressBar/ProgressBar.component';
import { useTask } from '../../../../context/Task';

export default function TaskExportBar() {
  const { loadingExport } = useTask();

  const getPercent = (total: number, current: number): number => {
    if (total && current) {
      return (current * 100) / total;
    }
    return 0;
  };

  return loadingExport.message ? (
    <Grid
      container
      style={{
        position: 'absolute',
        left: '0',
        top: '0',
        zIndex: '1',
        justifyContent: 'flex-end',
        alignItems: 'center',
        display: 'flex',
        padding: '10px',
      }}
    >
      <Grid item xs={2} sm={6} lg={7} />
      <Grid
        item
        xs={8}
        sm={4}
        lg={3}
        style={{
          backgroundColor: '#fff',
          opacity: '.99',
          border: '.5px solid #ddd',
          borderRadius: '20px',
          padding: '12px',
          boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
        }}
      >
        <span style={{ fontWeight: '500' }}>Exportação de Relatório</span>
        <ProgressBar
          value={getPercent(loadingExport.total, loadingExport.current)}
          style={{
            height: '5px',
            width: '100%',
          }}
        />
        <span style={{ fontSize: '12px' }}>{loadingExport.message}</span>
      </Grid>
      <Grid item xs={2} sm={2} lg={2} />
    </Grid>
  ) : (
    <></>
  );
}
